import Vue from "vue";

export default function RoutePermission({ next, to }) {
  if (!Vue.$cookies.isKey("back_office_admin_token")) return next("/");
  // if (Vue.$cookies.isKey("back_office_admin_token")) return next("/welcome");

  return next();
}
